/** @jsxImportSource @emotion/react */
import * as React from 'react';
import {HTMLAttributes} from 'react';
import cx from 'classnames';

const MainContent: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => {
  return (
    <div
      className={cx(
        'bg-white p-4 flex flex-col min-h-full text-[13px]',
        className,
      )}
      {...props}
    />
  );
};

export default MainContent;
